import { combineReducers } from 'redux';
import { PROMPT_LOGIN, SET_SERVER, SET_JWT } from '../actions/userAccess';
import { createFlagReducer } from '../utils/genericReducer';

export const userAccessReducer = combineReducers({
	promptLogin: createFlagReducer(PROMPT_LOGIN),
	server: createFlagReducer(SET_SERVER),
	jwtToken: createFlagReducer(SET_JWT)
});

// set up for middleware operations 
// helpful for making async and api calls
export const userAccessMiddleware = [];
